import http, { addTokenAndKeyParams } from '@/utils/http'

export const validateRegisterOfHelp = data => {
  return http({
    url: '/goldActivity/laborDay/isRegister',
    params: addTokenAndKeyParams(data)
  })
}
export const toHelp = data => {
  return http({
    url: '/goldActivity/laborDay/help',
    params: addTokenAndKeyParams(data)
  })
}
export const getHelpRecord = data => {
  return http({
    url: '/goldActivity/laborDay/getHelpRecord',
    params: data
  })
}

export const toLogin = data => {
  return http({
    url: '/user/doLoginJson.json',
    method: 'post',
    data: addTokenAndKeyParams(data)
  })
}
export const toSignUp = data => {
  return http({
    url: '/user/doRegisterJson.json',
    method: 'post',
    data
  })
}
